// AUTO-GENERATED by scripts/generate-dist-proxies.js
module.exports = require('./sentry-shared/index.js');
